// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3eGQQ","productName":"Table_productName__3Wc_q"};